module.exports = __webpack_public_path__ + "img/danielapardo.aa7b76ac.jpg";